import { MARKET_DATA_ACTIONS } from "constants/actions";

export function fetchMarketData(id) {
    return {
        type: MARKET_DATA_ACTIONS.FETCH_MARKET_DATA,
        payload:{
            id
        }
    };
}

export function fetchedMarketData(id, data) {
    return {
        type: MARKET_DATA_ACTIONS.FETCHED_MARKET_DATA,
        payload:{
            id,
            data
        }
    };
}

export function failedFetchMarketData(error) {
    return {
        type: MARKET_DATA_ACTIONS.FAILED_FETCH_MARKET_DATA,
        payload:{
            error
        }
    };
}

export function createMarketData(id, market_data) {
    return {
        type: MARKET_DATA_ACTIONS.CREATE_MARKET_DATA,
        payload:{
            id,
            market_data
        }
    };
}

export function createdMarketData(id, market_data) {
    return {
        type: MARKET_DATA_ACTIONS.CREATED_MARKET_DATA,
        payload:{
            id,
            market_data
        }
    };
}

export function failedCreateMarketData(error) {
    return {
        type: MARKET_DATA_ACTIONS.FAILED_CREATE_MARKET_DATA,
        payload:{
            error
        }
    };
}

export function updateMarketData(id, market_data) {
    return {
        type: MARKET_DATA_ACTIONS.UPDATE_MARKET_DATA,
        payload:{
            id,
            market_data
        }
    };
}

export function updatedMarketData(id, market_data) {
    return {
        type: MARKET_DATA_ACTIONS.UPDATED_MARKET_DATA,
        payload:{
            id,
            market_data
        }
    };
}

export function failedUpdateMarketData(error) {
    return {
        type: MARKET_DATA_ACTIONS.FAILED_UPDATE_MARKET_DATA,
        payload:{
            error
        }
    };
}